import React from 'react';
import ChangePricingEligibility from '../../component/update-pricing-eligibility';

interface Props {
  pricingEligibility?: string | null;
}

export const PricingEligibilityComponent = ({ pricingEligibility }: Props) => {
  return (
    <div className="create-txa-container">
      <h2>Choose pricing eligibility</h2>
      <ChangePricingEligibility pricingEligibility={pricingEligibility} />
    </div>
  );
};
